// extracted by mini-css-extract-plugin
export default {"uppercase":"uppercase__vsE6G","hidden":"hidden__KEZQT","NavLink":"NavLink__v64S2"};